import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  latitude: null,
  longitude: null,
  title: "",
  subtext: "",
  place_id: ""
};

const pickupLocationSlice = createSlice({
  name: 'pickupLocation',
  initialState,
  reducers: {
    setPickupLocation: (state, action) => {
      const { latitude, longitude, title, subtext, place_id } = action.payload;
      state.latitude = latitude;
      state.longitude = longitude;
      state.title = title;
      state.subtext = subtext;
      state.place_id = place_id;
    },
    clearPickupLocation: (state) => {
      state.latitude = null;
      state.longitude = null;
      state.title = "";
      state.subtext = "";
      state.place_id = "";
    }
  }
});

export const { setPickupLocation, clearPickupLocation } = pickupLocationSlice.actions;
export default pickupLocationSlice.reducer;
